//@ts-nocheck
import React, { Component } from "react";
import { get, post } from "../../../../requests";
import MDButton from "../../../../components/MDButton";
import MDBox from "../../../../components/MDBox";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Typography,
  TextField,
  CircularProgress,
} from "@mui/material";

interface FlinksComponentProps {
  loadFlinksBanksFromServer?: (dealApplicationId: any) => void;
  setAlert: (message: string) => void;
  setSuccessAlert: (message: string) => void;
  setBank: (bank: any) => void;
  handleAccountRefresh: (bank: any) => void;
  merchantId?: string;
  dealApplicationId?: string;
  funderPartyId?: number;
  flinksBanks?: any[];
  flinksApiError?: { accountId: string; message: string; entityType: string };
  setFlinksApiError?: (
    error: { accountId: string; message: string; entityType: string } | null
  ) => void;
}

interface FlinksComponentState {
  tenant: string;
  showContactModal: boolean;
  contactOptions: any[];
  selectedContact: any;
  isLoadingContacts: boolean;
  partyId?: string;
  showFlinksModal: boolean;
  flinksIframeUrl: string | null;
  iframeLoading: boolean;
  showLoadingOverlay: boolean;
  authToken?: string;
}

class FlinksComponent extends Component<FlinksComponentProps, FlinksComponentState> {
  constructor(props: FlinksComponentProps) {
    super(props);
    this.state = {
      tenant: "",
      showContactModal: false,
      contactOptions: [],
      selectedContact: null,
      isLoadingContacts: false,
      showFlinksModal: false,
      flinksIframeUrl: null,
      iframeLoading: false,
      showLoadingOverlay: false,
    };
  }

  componentDidMount() {
    let tenant = localStorage.getItem("currentTenant");
    if (tenant) {
      tenant = tenant.replace("_", " ").toUpperCase();
    } else {
      tenant = "";
    }
    this.setState({ tenant });
    this.fetchPartyId();
    window.addEventListener("message", this.handleFlinksMessage);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleFlinksMessage);
  }

  handleFlinksMessage = (event: MessageEvent) => {
    if (event.origin !== "https://smartmca-iframe.private.fin.ag") {
      console.log("Message from unexpected origin:", event.origin);
      return;
    }

    const data = event.data;

    console.log(JSON.stringify(data, null, 2));

    if (data?.step === "REDIRECT") {
      console.log(" REDIRECT received!");
      console.log("LoginId:", data.loginId);
      console.log("Institution:", data.institution);

      if (data.loginId) {
        this.setState({
          showFlinksModal: false,
          flinksIframeUrl: null,
          iframeLoading: false,
        });

        this.props.setSuccessAlert(
          "Processing your bank connection. This may take a few moments..."
        );

        console.log("=== STARTING POLLING FOR WEBHOOK COMPLETION ===");

        const funderPartyId = this.state.funderPartyId;
        if (!funderPartyId) {
          console.error(" No funderPartyId found in state!");
          this.props.setAlert("An error occurred. Please try again.");
          return;
        }

        this.pollForBankStatus(data.loginId, funderPartyId);
      } else {
        console.error("REDIRECT received but no loginId found");
        this.props.setAlert("Bank connection incomplete. No login ID received.");
        this.setState({ showFlinksModal: false, flinksIframeUrl: null });
      }
    } else if (data?.step === "CANCELLED" || data?.step === "COMPONENT_CLOSE") {
      console.log("User cancelled Flinks connection");
      this.setState({ showFlinksModal: false, flinksIframeUrl: null });
    } else if (data?.error || data?.step === "ERROR") {
      console.error("Flinks Connect Error:", data);
      this.handleFlinksError(data);
    } else if (data?.step === "TOKEN_INVALID") {
      console.warn("TOKEN_INVALID received");
    } else {
      console.log("Flinks step:", data?.step);
    }
  };

  pollForBankStatus = async (loginId: string, funderPartyId: number, attempts: number = 0) => {
    const MAX_ATTEMPTS = 10;
    const POLL_INTERVAL = 5000;

    if (attempts >= MAX_ATTEMPTS) {
      console.error("Polling timed out after", MAX_ATTEMPTS, "attempts");
      this.props.setAlert("Failed to connect to the Bank. Please try again later.");
      this.setState({
        showFlinksModal: false,
        flinksIframeUrl: null,
        iframeLoading: false,
      });
      return;
    }

    try {
      console.log(`Polling attempt ${attempts + 1}/${MAX_ATTEMPTS}...`);
      await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL));

      const response = await get(
        `flinksService/checkBankStatus?loginId=${loginId}&dealApplicationId=${this.props.dealApplicationId}&partyId=${funderPartyId}`
      );
      console.log("Poll response:", response);
      if (response.status === "ready") {
        console.log("ank connection complete!");
        console.log("Bank ID:", response.bankId);
        console.log("Institution:", response.institutionName);
        console.log("Accounts:", response.accountCount);

        const accountText =
          response.accountCount === 1 ? "1 account" : `${response.accountCount} accounts`;

        this.props.setSuccessAlert(
          `Successfully connected to ${response.institutionName}! ${accountText} imported.`
        );

        if (this.props.loadFlinksBanksFromServer) {
          console.log("Refreshing banks list...");
          await this.props.loadFlinksBanksFromServer(this.props.dealApplicationId);
          console.log("Banks list refreshed");
        } else if (this.props.loadBanksFromServer) {
          console.log("Refreshing banks list...");
          await this.props.loadBanksFromServer(this.props.dealApplicationId);
          console.log("Banks list refreshed");
        }
      } else if (response.status === "processing") {
        console.log("Still processing, polling again...");

        if (attempts > 0 && attempts % 3 === 0) {
          this.props.setSuccessAlert(
            `Still processing your bank connection... (${attempts}/${MAX_ATTEMPTS})`
          );
        }

        await this.pollForBankStatus(loginId, funderPartyId, attempts + 1);
      } else if (response.status === "error") {
        console.error("Error:", response.message);
        this.props.setAlert(
          response.message || "An error occurred processing your bank connection."
        );
        this.setState({
          showFlinksModal: false,
          flinksIframeUrl: null,
          iframeLoading: false,
        });
      }
    } catch (error: any) {
      console.error("Error polling bank status:", error);

      if (attempts < MAX_ATTEMPTS) {
        console.log("Poll failed, retrying...");
        await this.pollForBankStatus(loginId, funderPartyId, attempts + 1);
      } else {
        this.props.setAlert("Failed to verify bank connection. Please refresh the page.");
        this.setState({
          showFlinksModal: false,
          flinksIframeUrl: null,
          iframeLoading: false,
        });
      }
    }
  };

  fetchPartyId = async () => {
    const { dealApplicationId } = this.props;
    if (!dealApplicationId) return;

    this.setState({ isLoadingContacts: true });

    try {
      const response = await get(`getDealApplication/${dealApplicationId}`);
      if (response?.partyId) {
        this.setState({ partyId: response.partyId });
      }
    } catch (error) {
      console.error("Error fetching application details:", error);
    } finally {
      this.setState({ isLoadingContacts: false });
    }
  };

  handleOpenContactModal = () => {
    this.setState({ showContactModal: true });
    this.fetchContacts();
  };

  handleCloseContactModal = () => {
    this.setState({ showContactModal: false, selectedContact: null });
  };

  fetchContacts = () => {
    const { dealApplicationId } = this.props;
    if (!dealApplicationId) return;

    this.setState({ isLoadingContacts: true });
    get(`deal/getContacts/${dealApplicationId}`)
      .then((response) => {
        const options = response.map((contact: any) => ({
          label: `${contact.firstName} ${contact.lastName} (${
            contact.email || "no email available"
          })`,
          value: contact.id,
          email: contact.email,
          originalData: contact,
        }));
        this.setState({
          contactOptions: options,
          isLoadingContacts: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching contacts:", error);
        this.setState({ isLoadingContacts: false });
      });
  };

  handleSubmitContact = async () => {
    const { selectedContact, partyId } = this.state;
    if (!selectedContact || !selectedContact.email) {
      this.props.setAlert("Selected contact has no email address");
      return;
    }

    const contactData = selectedContact.originalData;

    try {
      const emailPayload = {
        recipient: selectedContact.email,
        userName: `${contactData.firstName} ${contactData.lastName}`,
        email: selectedContact.email,
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        dealApplicationId: Number(this.props.dealApplicationId),
        tenantId: Number(localStorage.getItem("tenantId")),
        entityType: "MERCHANT",
        currentTenant: localStorage.getItem("currentTenant"),
        currentUserEmail: localStorage.getItem("currentUserEmail"),
      };

      console.log("Sending Flinks link email:", emailPayload);

      await post("/flinksService/sendFlinksLinkEmail", emailPayload);

      this.props.setSuccessAlert(
        `Flinks sign-in link has been successfully sent to ${selectedContact.email}`
      );
      this.handleCloseContactModal();
    } catch (error: any) {
      console.error("Error sending Flinks link:", error);
      const errorMsg = error.response?.data?.error || "Failed to send Flinks link";
      this.props.setAlert(errorMsg);
    }
  };

  handleManualLogin = async () => {
    this.handleCloseContactModal();

    try {
      console.log("=== FUNDER FLOW: Generating iframe URL with tag ===");

      const tenantId = Number(localStorage.getItem("tenantId"));

      const response = await post("flinksService/generateIframeUrl", {
        tenantId: tenantId,
        dealApplicationId: Number(this.props.dealApplicationId),
      });

      console.log("Response:", response);

      if (response.status === "error") {
        this.props.setAlert(response.message || "Failed to generate Flinks URL");
        return;
      }

      const flinksIframeUrl = response.iframeUrl;
      const tag = response.tag;
      const funderPartyId = response.funderPartyId;

      console.log("Generated iframe URL:", flinksIframeUrl);
      console.log("Tag:", tag);
      console.log("Funder Party ID:", funderPartyId);

      this.setState({
        flinksIframeUrl: flinksIframeUrl,
        funderPartyId: funderPartyId,
        showFlinksModal: true,
        iframeLoading: true,
      });

      console.log("Iframe opened with tag, waiting for user authentication");
    } catch (error: any) {
      console.error("Error generating Flinks iframe URL:", error);
      this.props.setAlert("Failed to initialize Flinks Connect. Please try again.");
    }
  };

  handleFlinksError = (error: any) => {
    console.error("Flinks Connect Error:", error);
    this.setState({ showFlinksModal: false, flinksIframeUrl: null });
    this.props.setAlert("Flinks connection failed. Please try again.");
  };

  handleCloseFlinksModal = () => {
    this.setState({
      showFlinksModal: false,
      flinksIframeUrl: null,
      iframeLoading: false,
    });
  };

  render() {
    const {
      showContactModal,
      selectedContact,
      isLoadingContacts,
      showFlinksModal,
      flinksIframeUrl,
      iframeLoading,
      showLoadingOverlay,
    } = this.state;

    return (
      <>
        <MDButton variant="gradient" color="primary" onClick={this.handleOpenContactModal}>
          Login with Flinks
        </MDButton>

        <Dialog
          open={showContactModal}
          onClose={this.handleCloseContactModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>INITIATE FLINKS</DialogTitle>

          <DialogContent>
            <MDBox marginTop={3} marginBottom={4}>
              <Autocomplete
                options={this.state.contactOptions.map((opt) => opt.originalData)}
                getOptionLabel={(option) =>
                  `${option.firstName} ${option.lastName} (${option.email || "No Email Available"})`
                }
                value={selectedContact?.originalData || null}
                onChange={(event, newValue) => {
                  const selected = this.state.contactOptions.find(
                    (opt) => opt.originalData.id === newValue?.id
                  );
                  this.setState({ selectedContact: selected });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Contact" variant="outlined" required />
                )}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                loading={isLoadingContacts}
              />
            </MDBox>

            <MDBox display="flex" flexDirection="column" mb={1} gap={1}>
              <Typography variant="h1" sx={{ fontSize: 14 }}>
                INSTRUCTIONS
              </Typography>
              <Typography sx={{ fontSize: 14 }}>
                Select a merchant contact to send the Flinks link via email. The merchant will
                receive instructions to securely connect their bank account.
              </Typography>
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton variant="contained" color="error" onClick={this.handleCloseContactModal}>
              Cancel
            </MDButton>

            <MDButton
              variant="contained"
              color="primary"
              onClick={this.handleSubmitContact}
              disabled={!selectedContact || !selectedContact.email}
            >
              Send Link
            </MDButton>

            <MDButton color="info" onClick={this.handleManualLogin}>
              Manual Login
            </MDButton>
          </DialogActions>
        </Dialog>

        {showLoadingOverlay && (
          <MDBox
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(0, 0, 0, 0.3)"
            zIndex={1300}
          >
            <CircularProgress size={50} thickness={4} />
          </MDBox>
        )}

        <Dialog
          open={showFlinksModal}
          onClose={this.handleCloseFlinksModal}
          PaperProps={{
            style: {
              width: "500px",
              height: "680px", // Made taller as requested
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            },
          }}
          sx={{
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
            },
          }}
        >
          <DialogContent
            style={{
              padding: 0,
              height: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {iframeLoading && (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="white"
                zIndex={2}
              >
                <CircularProgress size={40} thickness={4} />
              </MDBox>
            )}

            {flinksIframeUrl && (
              <iframe
                src={flinksIframeUrl}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                }}
                title="Flinks Connect"
                allow="camera"
                onLoad={() => {
                  this.setState({ iframeLoading: false });
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

export default FlinksComponent;
